export default __webpack_public_path__ + "static/media/blob_07.4659f286.mp4";